import { ReportExportDialog } from '@app/modules/audit/screens/global-reports/common/ReportExportDialog';
import { Download } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';

export interface ReportExportParams {
  format: string;
  definitionId: string;
}

interface ReportWithType {
  id: string;
  type: string;
  /** Optional; when present, report.data.export.options.definitionId is used as default in the export dialog. */
  data?: {
    export?: {
      options?: {
        definitionId?: string;
      };
    };
  };
}

interface Props {
  report: ReportWithType;
  exportFn: (params: ReportExportParams) => string;
}

const LOADING_DELAY_MS = 1500;

/**
 * Self-contained export button that opens the generic ReportExportDialog
 * for format and definition selection, then triggers download via exportFn
 * and shows loading state on the button.
 */
export function ReportExport({ report, exportFn }: Props) {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleConfirm = (params: ReportExportParams) => {
    setDialogOpen(false);
    setLoading(true);
    const url = exportFn(params);
    window.location.href = url;
    setTimeout(() => setLoading(false), LOADING_DELAY_MS);
  };

  return (
    <>
      <Button
        color="info"
        variant="outlined"
        fullWidth
        loading={loading}
        loadingPosition="start"
        startIcon={<Download />}
        onClick={() => setDialogOpen(true)}
      >
        <FormattedMessage id="audit.reportsView.exportBtn" defaultMessage="Descargar reporte" />
      </Button>
      <ReportExportDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        reportType={report.type}
        initialDefinitionId={report.data?.export?.options?.definitionId}
        onConfirm={handleConfirm}
      />
    </>
  );
}
